import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabase';
import '../styles/ClientLogin.css';

function ResetPassword() {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    try {
      const { error } = await supabase.auth.updateUser({
        password: password
      });

      if (error) throw error;

      // Sign out after successful password update
      await supabase.auth.signOut();
      
      // Navigate to home page
      navigate('/');
    } catch (error) {
      setError(error.message);
    }
  };

  return (
    <div className="client-login-container">
      <div className="login-section">
        <div className="login-container">
          <h1 className="login-title">Reset Password</h1>
          
          {error && <p className="error-message">{error}</p>}

          <div className="login-form">
            <form onSubmit={handleSubmit}>
              <input
                type="password"
                placeholder="New Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <input
                type="password"
                placeholder="Confirm Password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              />
              <button 
                type="submit" 
                style={{ 
                  outline: 'none',
                  border: '1px solid #ccc',
                  transition: 'border-color 0.2s ease'
                }}
                onFocus={(e) => e.target.style.borderColor = '#abf44c'}
                onBlur={(e) => e.target.style.borderColor = '#ccc'}
              >
                Update Password
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ResetPassword; 